import React from 'react';
import SettingsPage from './settings/container/settings';
import {hasAccess} from '../app/user';

export default () => {
  // if user is internal, settings cannot be saved
  const canSave = !hasAccess(['videoIntelligenceInternal']);
  /* TODO: add tabs */
  return (
    <div>
      <SettingsPage userCanSave={canSave} />
    </div>
  );
}
